import { MEDIA_QUERIES, SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

interface EmptyRowProps {
  rows?: number;
  rowsMobile?: number;
}

/**
 * A simple spacer element used to provide vertical space in grids.
 */
const EmptyRow = styled('div').attrs(() => ({ 'aria-hidden': true }))<EmptyRowProps>`
  grid-row-end: span ${(p) => p.rows || 1};
  @media ${MEDIA_QUERIES.isMobile} {
    grid-row-end: span ${(p) => p.rowsMobile || p.rows || 1};
  }

  /**
   * TODO: PER-1771 Remove once all forms are migrated
   * Currently the spacing exists in <FormGroup/> for backwards compatibility
   **/
  margin-bottom: ${(p) => SPACINGS.base * 3 * (p.rows || 1)}px;
`;

export default EmptyRow;
